exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-article-1-js": () => import("./../../../src/pages/article-1.js" /* webpackChunkName: "component---src-pages-article-1-js" */),
  "component---src-pages-article-2-js": () => import("./../../../src/pages/article-2.js" /* webpackChunkName: "component---src-pages-article-2-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

